import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'
import FormDivider from '@/agilis/components/Form/FormDivider/FormDivider.vue'
import MarkdownViewer from '@/agilis/components/Form/FormMarkdown/viewer/MarkdownViewer.vue'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import BooleanRenderer from '@/agilis/components/BooleanRenderer/BooleanRenderer.vue'

import linkToMixin from '@/agilis/components/DataTableV2/common/linkToMixin'
import CollapsibleDividerMixin from '@/agilis/components/Form/utils/CollapsibleDividerMixin'
import jsonLogic from '@/plugins/jsonLogic'

export default {
  name: 'EntityDetails',

  mixins: [linkToMixin, CollapsibleDividerMixin],

  components: {
    FormDivider,
    MarkdownViewer,
    UnStyledLink,
    BooleanRenderer
  },

  props: {
    trackerDTO: Object,
    dataTable: Object,
    formRows: Array, // custom formRows specified by the parent component; when not specified, will read from tracker configuration,
    jlAssertionContext: {
      type: Object,
      default: () => ({})
    },
    showDivider: Boolean
  },

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId',
      dataTableById: 'contextStore/trackerDataTableById'
    }),

    selectedContext () {
      return {
        applicationId: this.applicationId,
        workspaceId: this.workspaceId,
        trackerTypeId: this.trackerDTO?.trackerTypeId
      }
    },

    configuration () {
      return this.dataTable || this.dataTableById(this.trackerDTO?.trackerTypeId)
    },

    maxFormColumns () {
      const formRows = this.formRows || this.configuration?.formRows || []
      return formRows.reduce(function (result, element) {
        return result >= element.cols.length * 2 ? result : element.cols.length * 2
      }, 0)
    },

    formFields () {
      const formColumns = this.configuration?.columns || {}

      const formElements = Object.entries(this.configuration?.formElements || {}).reduce((acc, [key, value]) => {
        if (value.type === 'divider') {
          return {
            ...acc,
            [key]: value
          }
        }
        return acc
      }, {})

      return {
        ...formColumns,
        ...formElements
      }
    },

    formRowsForView () {
      const formRows = this.formRows || this.configuration?.formRows || []
      let resultRows = []
      formRows.forEach((formRow) => {
        let row = { cols: [] }
        formRow.cols.forEach((colId) => {
          if (this.userCanAccessField(colId) && // user has permissions
            this.showWhenConditions[colId] // field has an active showWhen condition
          ) {
            if (this.formFields[colId] && this.formFields[colId].type === 'divider') {
              row.cols.push(colId)
            } else {
              row.cols.push(colId) // adding 2 elem to handle col label + col value
              row.cols.push(colId)
            }
          }
        })
        if (row.cols.length > 0) resultRows.push(row)
      })
      return resultRows
    },

    visibleRows () {
      return this.getVisibleRows(this.formRowsForView, this.formFields)
    },

    showWhenConditions () {
      return Object.entries(this.formFields).reduce((acc, [fieldId, field]) => {
        if (field.showWhen && field.showWhen.jsonLogic) {
          const show = jsonLogic.apply(field.showWhen.jsonLogic, this.trackerDTO)
          return Object.assign(acc, { [fieldId]: show })
        }
        return Object.assign(acc, { [fieldId]: true })
      }, {})
    }

  },

  methods: {
    renderColumn (colConfig, item) {
      if (colConfig.computed) {
        item[colConfig.id] = jsonLogic.apply(colConfig.computed.jsonLogic, this.jlAssertionContext)
      }
      return Configuration.datatable.renderColumn(colConfig, item)
    },

    userCanAccessField (colId) {
      return Configuration.auth.userCanAccessField(this.selectedContext, colId, null, 'get')
    }
  }
}
